import React from "react";
import styled from "styled-components";
import { t } from "i18next";
import { Trans } from "react-i18next";
import * as R from "ramda";

import { PrimaryButtonS, Text, TextArea, TextInput } from "../../common";
import { DisplayFlexS } from "../../../../utils/stylesHelpers";
import {getScreenSize, getThemeColor, getThemeFont, getThemeSize} from "../../../../utils/theme";


const Form = styled.form`
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
  background-color: ${getThemeColor(['white'])};
  width: 100%;
`;

const FormTitle = styled(Text)`
  font-size: ${getThemeSize(['headers', 'secondary'])};
  font-family: ${getThemeFont(['bold'])};
  color: ${getThemeColor(['violet'])};
  text-align: center;
`;

const InputWrapper = styled.div`
  width: ${R.propOr('100%', 'width')};
  margin-bottom: 20px;
  
  @media (max-width: ${getScreenSize(['medium'])}) {
     margin-bottom: 15px;
     flex-basis: ${R.propOr('100%', 'mobileWidth')};
     width: 100%;
  }
`;

const CustomInputTitle = styled.span`
  display: inline-block;
  font-family: ${getThemeFont('regular')};
  font-size: ${getThemeSize(['largeText'])};
  color: ${getThemeColor(['violet'])};
  text-transform: uppercase;
  margin-bottom: 5px;
`;

const ContactFormComponent = ({
  values,
  errors,
  touched,
  onSubmit,
  onChange,
  onBlur,
}) => (
  <Form {...{ onSubmit }}>
    <DisplayFlexS
      direction='column'
      directionScreenMedium='column'
      aItems='center'
      alignItemsScreenMedium='center'
      style={{ padding: 35 }}
    >
      <FormTitle>
        <Trans i18nKey="contactsPage.titleForm" />
      </FormTitle>

      <DisplayFlexS direction='column' directionScreenMedium='column' style={{ marginTop: 35 }}>
        <InputWrapper width='100%'>
          <CustomInputTitle>{t('contactsPage.form.labels.name')}</CustomInputTitle>
          <TextInput
            placeholder={t('contactsPage.form.placeholders.name')}
            name="name"
            type="text"
            value={ values.name }
            {...{ onChange, onBlur }}
            isError={errors.name && R.prop('name', touched)}
            error={errors.name}
          />
        </InputWrapper>
        <InputWrapper width='100%'>
          <CustomInputTitle>{t('contactsPage.form.labels.email')}</CustomInputTitle>
          <TextInput
            placeholder={t('contactsPage.form.placeholders.email')}
            name="email"
            type="text"
            value={values.email}
            {...{ onChange, onBlur }}
            isError={errors.email && touched.email}
            error={errors.email}
          />
        </InputWrapper>

        <InputWrapper>
          <CustomInputTitle>{t('contactsPage.form.labels.text')}</CustomInputTitle>
          <TextArea
            placeholder={t('contactsPage.form.placeholders.text')}
            name="text"
            type="text"
            value={values.text}
            rows="8"
            {...{ onChange, onBlur }}
            isError={errors.text && touched.text}
            error={errors.text}
          />
        </InputWrapper>

        <DisplayFlexS justify='center' justifyScreenMedium='center' style={{margin: '5px auto 10px'}}>
          <PrimaryButtonS type='submit' padding='15px 55px'>
            <Trans i18nKey="contactsPage.submitBtn" />
          </PrimaryButtonS>
        </DisplayFlexS>
      </DisplayFlexS>
    </DisplayFlexS>
  </Form>
);

export default ContactFormComponent;
